import axios from "axios";
import { ROLE_LIST, ADD_ROLE, SET_ERROR, USER_ROLE_PERMISSION, ROLE_CONFIG } from "../../types";
import ToastMessage from '../../../components/toast';

export const AddRoleAction = (payload) => {

    return async (dispatch) => {

        await axios.post(`api/role/add-role`, payload).then(response => {
            dispatch({
                type: ADD_ROLE,
                payload: response.data.data
            });
            ToastMessage("Successfully submitted", "success");
        }).catch(e => {
            ToastMessage(e, "error");
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};

export const removeRole = async (id) => {
    let response = await axios.delete(`api/role/delete/${id}`);
    return response.data || []
};

export const GetRoleAction = (company) => {
    return async (dispatch) => {
        await axios.post(`api/role/get-role/${company}`).then(response => {
            dispatch({
                type: ROLE_LIST,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};
export const UpdateRoleAction = (payload) => {
    return async (dispatch) => {
        await axios.put(`api/role/update-role`, payload).then(response => {
            dispatch({
                type: ADD_ROLE,
                payload: response.data.data
            });
            ToastMessage("Successfully submitted", "success");
        }).catch(e => {

            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
            ToastMessage(e, "error");
        })
    }
};
export const GetRolePermissionAction = (username) => {

    return async (dispatch) => {
        await axios.post(`api/role/get-role-by-username/${username}`).then(response => {

            dispatch({
                type: USER_ROLE_PERMISSION,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};
export const GetRole = async (username) => {
    let response = await axios.get(`api/role/get-role-by-username/${username}`);
    return response?.data;
};

export const GetRoleConfig = () => {

    return async (dispatch) => {
        await axios.get(`api/role/get-role-config`).then(response => {

            dispatch({
                type: ROLE_CONFIG,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }

};
